<template>
  <v-menu v-model="menu" :close-on-content-click="false" left bottom offset-y>
    <template #activator="{ props }">
      <div class="copy-criteria-wrapper" @click.stop>
        <mf-button
          v-bind="props"
          class="pr-1"
          color="cinza-0"
          icon="control_point_duplicate"
          type="icon"
          size="sm"
          :class="[selectedCriteria ? 'hidden-close' : '']"
          :disabled="viewOnly"
          @click="handleButtonClick"
        />
      </div>
    </template>

    <v-card min-width="300">
      <v-list>
        <v-list-item v-for="(item, i) in menuItems" :key="i" :value="item" @click="handleMenuClick(item)">
          <v-list-item-title
            >{{ item.title }}<b>{{ item.titleBold }}</b></v-list-item-title
          >
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CopyCriteriaButton',
  props: {
    viewOnly: {
      type: Boolean,
      default: false,
    },
    groupIndex: {
      type: Number,
      default: 0,
    },
    criteriaIndex: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    ...mapState({
      segmentationGroups: (state) => state.segmentation.segmentationGroups,
      selectedCriteria: (state) => state.segmentation.selectedCriteria,
    }),
    menuItems() {
      const menuItems = Array.from({ length: this.segmentationGroups.groups.length }, (_, i) => ({
        title: 'Copiar critério para o ',
        titleBold: `grupo ${i + 1}`,
        groupIndex: i,
      }))
      menuItems.push({
        title: 'Copiar critério para um ',
        titleBold: 'novo grupo',
        groupIndex: null,
      })
      return menuItems
    },
  },
  methods: {
    ...mapActions(['copyCriteriaToGroup']),
    handleMenuClick(item) {
      this.copyCriteriaToGroup({ groupIndex: this.groupIndex, criteriaIndex: this.criteriaIndex, newGroupIndex: item.groupIndex })
      this.menu = false
    },
    handleButtonClick() {
      this.menu = true
    },
  },
}
</script>

<style lang="scss" scoped>
.copy-criteria-wrapper {
  display: inline-block;
  margin-right: 4px;
}
</style>
